<template>
  <div class="change-pwd-root">
    <div class="pwd-card shadow-premium">
      <div class="text-center mb-4">
        <h2 class="fw-bold text-dark">Ganti Password</h2>
        <p class="text-muted small">Ini adalah login pertama Anda. Silakan atur password baru untuk keamanan akun.</p>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label class="form-label small fw-bold">Password Baru</label>
          <input 
            type="password" 
            v-model="newPassword" 
            class="form-control minimal-input" 
            placeholder="Masukkan password baru"
            required
          >
        </div>
        <div class="mb-4">
          <label class="form-label small fw-bold">Konfirmasi Password</label>
          <input 
            type="password" 
            v-model="confirmPassword" 
            class="form-control minimal-input" 
            placeholder="Ulangi password baru"
            required
          >
          <div v-if="error" class="text-danger small mt-2">{{ error }}</div>
        </div>

        <button 
          type="submit" 
          class="btn btn-primary w-100 py-2 fw-bold" 
          :disabled="loading"
        >
          {{ loading ? 'Memproses...' : 'Simpan Password Baru' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import authService from "@/services/authService";
import Swal from 'sweetalert2';

export default {
  setup() {
    const router = useRouter();
    const newPassword = ref('');
    const confirmPassword = ref('');
    const loading = ref(false);
    const error = ref('');

    const handleSubmit = async () => {
      if (newPassword.value !== confirmPassword.value) {
        error.value = 'Password tidak cocok!';
        return;
      }
      if (newPassword.value.length < 6) {
        error.value = 'Password minimal 6 karakter!';
        return;
      }

      error.value = '';
      loading.value = true;
      try {
        await authService.changePassword(newPassword.value);
        
        // Update local session
        const user = await authService.getCurrentUser();
        localStorage.setItem("currentUser", JSON.stringify(user));

        Swal.fire({
          icon: 'success',
          title: 'Sukses',
          text: 'Password berhasil diperbarui!',
          timer: 2000,
          showConfirmButton: false
        });

        router.push('/');
      } catch (e) {
        console.error(e);
        error.value = 'Gagal mengganti password. Silakan coba lagi.';
      } finally {
        loading.value = false;
      }
    };

    return {
      newPassword,
      confirmPassword,
      loading,
      error,
      handleSubmit
    };
  }
}
</script>

<style scoped>
.change-pwd-root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
}
.pwd-card {
  background: white;
  padding: 40px;
  border-radius: 20px;
  width: 100%;
  max-width: 400px;
}
.minimal-input {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 12px;
}
.btn-primary {
  background-color: #059468;
  border: none;
  border-radius: 10px;
}
.btn-primary:hover {
  background-color: #047857;
}
.shadow-premium {
  box-shadow: 0 20px 50px rgba(0,0,0,0.05);
}
</style>
